module.exports = __webpack_public_path__ + "img/Single_login.905b4b5c.svg";